module.exports = __webpack_public_path__ + "static/media/rocket.05196135.mp3";